import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsComponent } from '@app/shared/components/toasts/toasts.component';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [LoadingBarRouterModule, LoadingBarModule, RouterOutlet, ToastsComponent],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(
    modalService: NgbModal,
    platformLocation: PlatformLocation,
    private primeng: PrimeNG
  ) {
    // to dismiss all modals when the user navigates back or forward
    platformLocation.onPopState(() => modalService.dismissAll());
  }

  ngOnInit() {
    this.primeng.zIndex = {
      modal: 1055, // dialog, sidebar
      overlay: 1055, // dropdown, overlaypanel
      menu: 1070, // overlay menus
      tooltip: 1080 // tooltip
    };
  }
}
